module.exports = "/_next/static/images/hodl-ca0e0c3bb7242b548ced5ef49e4937ff.png";